<template>
  <div class="doc-box content-1200">
    <div class="text-center font-blod color-level1 margin-b20 fontSize36">标准文档</div>
    <div class="text-center color-level2 fontWeight-500 fontSize18 margin-b60">
      制定统一标准，树立行业标杆，构建规范体系
    </div>
    <div class="doc margin-b40 radius-8">
      <div class="relative" v-for="(item,index) in docList.slice(0,5)" :key="index">
        <img class="cursor" :src="item.image" alt="" @click="handleRun(item)">
      </div>
    </div>
    <more-button @handleClick="$router.push('/doc')"></more-button>
  </div>
</template>
<script>
import MoreButton from "@/components/common/MoreButton";

export default {
  components: {MoreButton},
  props: {
    docList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleRun(item) {
      if (!item.redirectUrl) return
      window.open(item.redirectUrl, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.doc-box {
  padding: 80px 0 40px;

  .doc {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    justify-content: space-between; /* 均匀分布 */

    img {
      border-radius: 8px;
      width: 224px;
      height: 317px;
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        transform: translateY(-30px);
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .doc-box {
    .doc {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between; /* 均匀分布 */
      .relative{
        padding:20px;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
